/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* Adding types to these store params will throw an TS lint error during FXP build time.*/

import * as fromWbsDbDetails from "./wbs-db.reducer";

export const getWbsDbState = (wbsId: string) => (store) => store.wbsDbDetails[wbsId] ? store.wbsDbDetails[wbsId] : fromWbsDbDetails.initialState;
export const getWbsDbDetails = (wbsId: string) => (store) => getWbsDbState(wbsId)(store).wbsDbDetails;
export const getWbsDbDetailsLoadingState = (wbsId: string) => (store): boolean => getWbsDbState(wbsId)(store).loading;
export const getWbsDbDetailsLoadedState = (wbsId: string) => (store): boolean => getWbsDbState(wbsId)(store).loaded;
export const getWbsDbDetailssErrorState = (wbsId: string) => (store): string => getWbsDbState(wbsId)(store).error;